import { render, staticRenderFns } from "./AddNewDeposit.vue?vue&type=template&id=6186e45e&scoped=true&"
import script from "./AddNewDeposit.vue?vue&type=script&lang=ts&"
export * from "./AddNewDeposit.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewDeposit.vue?vue&type=style&index=0&id=6186e45e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6186e45e",
  null
  
)

export default component.exports